import { useAppVersionChanged } from 'app/modules/navigator/queries/useAppVersion';
import { useState } from 'react';
import styled from 'styled-components';

import { IconAlertTriangleFilled } from '@u21/tabler-icons';
import {
  U21Alert,
  U21Button,
  U21MenuLayout,
} from 'app/shared/u21-ui/components';

export const reloadBrowser = () => window.location.reload();

interface VersionOutdatedPopoverProps {
  isOutdated: boolean;
}

export const VersionOutdatedPopover = ({
  isOutdated,
}: VersionOutdatedPopoverProps) => {
  const [open, setOpen] = useState(false);
  const closePopover = () => setOpen(false);

  const refreshBrowser = () => {
    closePopover();
    reloadBrowser();
  };

  if (isOutdated) {
    return (
      <U21MenuLayout
        alignRight
        onClose={closePopover}
        open={open}
        trigger={
          <U21Button
            aria-label="app-warning"
            aria-expanded={open}
            aria-haspopup="dialog"
            color="warning"
            icon={<IconAlertTriangleFilled />}
            onClick={() => setOpen(true)}
            onFocus={() => setOpen(true)}
            onMouseEnter={() => setOpen(true)}
          />
        }
      >
        <StyledU21Alert
          color="warning"
          onClose={closePopover}
          title="Application outdated"
        >
          Please save your work and{' '}
          <U21Button color="primary" onClick={refreshBrowser} variant="text">
            refresh your browser
          </U21Button>{' '}
          to get the latest version.
        </StyledU21Alert>
      </U21MenuLayout>
    );
  }
  return null;
};

export const VersionOutdatedIndicator = () => {
  const changed = useAppVersionChanged();

  return <VersionOutdatedPopover isOutdated={changed} />;
};

const StyledU21Alert = styled(U21Alert)`
  width: 300px;
`;
